import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center pt-20 pb-16 overflow-hidden" data-id="element-65">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10" data-id="element-66">
        <div className="absolute top-[-10%] right-[-5%] w-[50%] h-[50%] rounded-full bg-rose-light/20 blur-3xl" data-id="element-67" />
        <div className="absolute bottom-[-10%] left-[-5%] w-[40%] h-[40%] rounded-full bg-gold-light/20 blur-3xl" data-id="element-68" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-69">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-70">
          <div className="order-2 lg:order-1 max-w-2xl" data-id="element-71">
            <FadeIn delay={0.1} data-id="element-72">
              <span className="inline-block py-1 px-3 rounded-full bg-rose-light/30 text-brown-light text-sm font-bold tracking-widest uppercase mb-6" data-id="element-73">
                Programa de Transformación
              </span>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-74">
              <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif text-brown leading-tight mb-6" data-id="element-75">
                El Código de la{' '}
                <span className="text-gold italic" data-id="element-76">Suavidad</span>
              </h1>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-77">
              <p className="text-xl md:text-2xl text-brown-light font-serif mb-6 leading-relaxed" data-id="element-78">
                El Manual para la Mujer que está Cansada de "Poder con Todo".
              </p>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-79">
              <p className="text-lg text-brown/80 mb-10 leading-relaxed" data-id="element-80">
                Recupera tu magnetismo femenino, suelta la carga mental y deja
                de ser el "hombre de la casa" sin perder tu seguridad.
              </p>
            </FadeIn>

            <FadeIn delay={0.5} data-id="element-81">
              <Button size="lg" scrollTo="offer-section" className="w-full sm:w-auto" data-id="element-82">
                SÍ, QUIERO RECUPERAR MI SUAVIDAD
              </Button>
            </FadeIn>
          </div>

          <div className="order-1 lg:order-2 relative" data-id="element-83">
            <FadeIn direction="left" delay={0.3} data-id="element-84">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-brown/10 aspect-[4/3] lg:aspect-square max-w-md mx-auto lg:max-w-none" data-id="element-85">
                <div className="absolute inset-0 bg-gradient-to-tr from-brown/10 to-transparent z-10 rounded-2xl" data-id="element-86" />
                <img src="https://cdn.magicpatterns.com/uploads/nppRCaveYAFArqMXxxVnjh/Elcodigo_de_la_suavidad.png" alt="El Código de la Suavidad eBook y Programa" className="w-full h-full object-cover rounded-2xl" data-id="element-87" />
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}